const SET_CONTEXT = 'SET_CONTEXT';
const SYNC_CONTEXT = 'SYNC_CONTEXT';

export {
  SET_CONTEXT,
  SYNC_CONTEXT,
};
